import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { SET_CURRENT_PATH } from '@actions/types'

const PathComponent = ({ children, path }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: SET_CURRENT_PATH, payload: path })
  }, [dispatch, path])

  return <>{children}</>
}

export default PathComponent
